// Copyright (c) 2016 Deere & Company

import TrackClaim from '@deere/cps-it.warranty-model-factory/lib/claim-track';

export const getUpdatedTrackClaim = (currentClaim, selectedAction) =>
    TrackClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/track/services/update-track-claim.js